import { useCityStore } from '~/stores/city'
import { useCityStorage } from '~/composables/useCityStorage'
import {
  canAutoRedirectGeoCatalog,
  canAutoRedirectToVisitSection,
  clearGeoCatalogCityFilterCleared,
  isGeoCatalogOnlinePath,
  isGeoCatalogSectionPath,
  performGeoCatalogCityRedirect,
  performVisitSectionRedirect,
} from '~/utils/geoCatalog'

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const { getStoredCity } = useCityStorage()
  const storedCity = getStoredCity()

  if (storedCity && canAutoRedirectToVisitSection(route.path, route.query)) {
    performVisitSectionRedirect(storedCity, route.query)

    return
  }

  if (storedCity && canAutoRedirectGeoCatalog(route.path, route.query)) {
    const pathWithSlash = route.path.endsWith('/') ? route.path : `${route.path}/`
    performGeoCatalogCityRedirect(pathWithSlash, storedCity, route.query)

    return
  }

  const cityStore = useCityStore()

  watch(
    () => route.path,
    (newPath, oldPath) => {
      if (!isGeoCatalogSectionPath(newPath)) {
        clearGeoCatalogCityFilterCleared()
        return
      }

      if (oldPath && isGeoCatalogOnlinePath(oldPath) && !isGeoCatalogOnlinePath(newPath)) {
        clearGeoCatalogCityFilterCleared()
      }
    },
  )

  watch(
    () => [route.path, route.query, cityStore.citySlug, cityStore.status] as const,
    () => {
      cityStore.redirectToCatalogCityIfNeeded()
    },
    { immediate: true },
  )
})
